import React, { useContext } from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';
import FormContext from '../../context/FormContext';
import FormGroupContext from '../../context/FormGroupContext';
/**
 * FormLabel component.
 */

var FormLabel = function FormLabel(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useContext = useContext(FormGroupContext),
      inputId = _useContext.inputId;

  var _useContext2 = useContext(FormContext),
      inverted = _useContext2.inverted;

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for
    React.createElement("label", {
      className: cn('form-label', className, inverted && 'form-label--inverted'),
      htmlFor: inputId
    }, children)
  );
};

FormLabel.defaultProps = {
  children: null,
  className: null
};
FormLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The label children. */
  children: node,

  /** Additional class names to add to the component root. */
  className: string
} : {};
export default FormLabel;